import React, { useState, useEffect,Fragment } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    Grid,
    Box
} from "@material-ui/core";
import { tripSelectionDialogCss } from './ExpensesDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import { FuelBookIcon, MaintenanceIcon, DriverExpensesIcon } from '../../../components/icons';
import { getTripDateFilterValues,numberFormat,vehicleNumberDisplay,findArrayObject } from '../../../utils/utils';
import { connect } from "react-redux";
import * as logger from '../../../logger';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import moment from 'moment';
import { getJourneys,selectedJourney } from '../../../store/actions/expensesActionCreators';
import { Waypoint } from "react-waypoint";
import { tripTableHeight } from '../../../styleVariables';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import MUIDataTable from 'mui-datatables';
import { data } from 'jquery';
const TripSelectionDialog = ({ open, 
    onClose,
    onConfirm, 
    user,
    expenses, 
    dispatchGetJounrneyListAction,
    dispatchSelectJourney
}) => {
    const [dialogOpen, setDialogOpen] = useState(open);
    const [journeysData,setJourneysData] = useState(null)
    const [searchText, setSearchText] = useState("");
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const classes = tripSelectionDialogCss();
    const journeyRequetsData = {
        fleetOwnerId: user.userInfo.entityId,
        search: searchText,
        searchText: searchText,
        filters: [
          {
            "filterKey": "tripStatus",
            "values": [
                "STARTED",
                "COMPLETED",
                "POD_RECEIVED",
                "POD_SUBMITTED"
            ]
          }
        ],
        pageNo: currentPageNo,
        pageSize: currentPageSize,
    };
    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }
    const handleSelectTrip = (e,trip)=>{
      e.preventDefault()
      if(trip && trip.journeyId){
        let journey = findArrayObject('id',trip.journeyId,journeysData.journeys);
        //dispatchSelectJourney(journey)
        onConfirm(journey)
      }
    }
    useEffect(() => {
        dispatchGetJounrneyListAction({ ...journeyRequetsData },
          () => {
          },
          () => {
          }
        )
      }, []);
    useEffect(() => {
        if (expenses.journeysData) {
            setJourneysData(expenses.journeysData);
        }
    }, [expenses.journeysData]);
    const onSearchBlur = debounce(query => {
        setCurrentPageNo(defaultPageNo)
        journeyRequetsData.pageNo = 1;
        dispatchGetJounrneyListAction({ ...journeyRequetsData,searchText:query, search: query },
          () => {
           
          },
          () => {
            
          }
        )
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
    const getPaginatedData = () => {
        const requestData = {
          ...journeyRequetsData,
          merge: true,
          fleetOwnerId: user.userInfo.entityId,
          pageNo: currentPageNo + 1,
          pageSize: currentPageSize,
          search: searchText,
          searchText:searchText,
        };
        dispatchGetJounrneyListAction({...requestData },
          () => {
            
          },
          () => {
          }
        )
    
    }
    const muiData = journeysData && journeysData.trips ? journeysData.trips : [];
    const muiColumns = [
        {
          name: "vehicle",
          label: "Truck No",
          options: {
            setCellProps: (value,rowIndex,columnIndex) => {
              let data = muiData[rowIndex]?muiData[rowIndex]:null
              return data&&data.grouping && data.groupClass?{className:classes[`${data.groupClass}`]}:{};
            },
            customBodyRenderLite: (dataIndex,rowIndex) => {
                let data = muiData[dataIndex];
                let vehicle = data.vehicle?data.vehicle:null;
                let value = (<Box display={'flex'} alignItems={'center'}>
                    <div className={classes.vehicleNumber}>{vehicleNumberDisplay(vehicle.vehicleNumber)}</div>
                    <div className={classes.ownershipType}>
                        <span className={vehicle && vehicle.ownershipType && vehicle.ownershipType == 'HIRED' ? classes.hired : classes.own}>{vehicle.ownershipType && vehicle.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                    </div>
                </Box>)
              if (rowIndex === muiData.length - 1) {
                return (
                  <Fragment>
                    <Waypoint
                      onEnter={() => {
                        if (journeysData && journeysData.maxPage && journeysData.maxPage != currentPageNo) {
                          setCurrentPageNo(currentPageNo+ 1);
                          getPaginatedData();
                        }
                      }}
                    />
                    {value}
                  </Fragment>
                );
              } else {
                return <Fragment>{value}</Fragment>;
              }
            }
          },
        },
        {
          name: "startDate",
          label: "Start Date",
          options: {
            customBodyRenderLite: (dataIndex,rowIndex) => {
                let data = muiData[dataIndex];
                return <span className={classes.vehicleNumber}>{data&& data.startDate?moment(Number(data.startDate)*1000).format("DD MMM YYYY"):''}</span>
            }
          }
        },
        {
          name: "customer",
          label: "Party Name",
          options: {
            customBodyRenderLite: (dataIndex,rowIndex) => {
                let data = muiData[dataIndex];
                return <span className={classes.vehicleNumber}>{data&& data.customer&& data.customer.customerName?data.customer.customerName:''}</span>
            }
          },
        },
        {
          name: "Route",
          label: "Route",
          options: {
            setCellProps: (value,rowIndex,columnIndex) => {
                //let data = muiData[rowIndex]?muiData[rowIndex]:null
                //return data&&data.grouping?{rowspan:data.rowSpan}:{};
            },
            customBodyRenderLite: (dataIndex,rowIndex) => {
                let data = muiData[dataIndex];
                return <span className={classes.vehicleNumber}>{data&& data.startLocation?data.startLocation:''}&nbsp;{`-->`}&nbsp;{data&& data.destinationLocation?data.destinationLocation:''}</span>
            }
          },
        },
        {
          name: "action",
          label: " ",
          options: {
            setCellProps: (value,rowIndex,columnIndex) => {
                let data = muiData[rowIndex]?muiData[rowIndex]:null
                return data&&data.grouping && data.groupClass?{className:classes[`${data.groupClass}`]}:{};
            },
            customBodyRenderLite: (dataIndex,rowIndex) => {
                let data = muiData[dataIndex];
                return <Box display={'flex'} justifyContent={'center'}>
                    <Button variant="contained" className={classes.addTripButton} onClick={(e)=>{handleSelectTrip(e,data)}} >
                              Select Trip
                    </Button>
                </Box>
            }
          },
        }
    ];
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        tableBodyHeight: tripTableHeight,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        sort: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        pagination: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
        },
        customToolbar: (data) => {
          return <>
          </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
    
        },
        searchProps: {
          // value: searchText,
          variant: "outlined",
          InputProps: {
            startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
          },
          onBlur: (e) => {
          },
          onKeyUp: (e) => {
          },
          onKeyDown: (event) => {
            if (event.keyCode === 27) {
            }
          }
        },
        searchPlaceholder: 'Search for Party ,Truck No, Origin or Destination ',
        onSearchChange: (val) => {
          let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
          setSearchText(value);
          if (value && value.length > 1) {
            onSearchBlur(value);
            setJourneysData({});
          } else if (searchText && value && value.trim().length <= 1) {
            setSearchText("");
            onSearchBlur("");
          }else{
            setSearchText("");
            onSearchBlur("");
          }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
          let isFound = true;
          return isFound;
        },
        textLabels: {
          body: {
            noMatch: "No Trips",
            toolTip: "Sort",
            columnHeaderTooltip: column => `Sort for ${column.label}`
          }
        }
    };
    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xl'
                onClose={handleClose} 
                disableEscapeKeyDown={true} 
                disableBackdropClick={true} 
                aria-labelledby="selct-trip-dialog-title" 
                open={dialogOpen} 
                classes={{ paper: classes.paper1 }}>
                <DialogTitle className={classes.dialogTitleV1}
            >
                    <div className={classes.divV1}>Select Trip</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent className={classes.dialogContentV1}>
                    <div className={classes.jounrneyTable}>
                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetJounrneyListAction: (data, onSuccess, onFailure) => dispatch(getJourneys(data, onSuccess, onFailure)),
    dispatchSelectJourney: (data) => dispatch(selectedJourney(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TripSelectionDialog);